export default {
    name: "Hint",
    props:[
        "hintText"
    ]
}